import { render, staticRenderFns } from "./tryoutProject.vue?vue&type=template&id=6ddb4bc9&scoped=true"
import script from "./tryoutProject.vue?vue&type=script&lang=js"
export * from "./tryoutProject.vue?vue&type=script&lang=js"
import style0 from "./tryoutProject.vue?vue&type=style&index=0&id=6ddb4bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb4bc9",
  null
  
)

export default component.exports